import React from 'react';
import '../less/main.less';
import Link from "MWComponents/dest/components/Link";

export default function template() {
  const {data} = this.props,
    infoItems = data.info.map((item, index) => {
      return(
        <div className="card-item-right-side-info-item" key={index}>
          <div className="card-item-right-side-info-item-title" dangerouslySetInnerHTML={{__html: this.l10n(item.title)}}></div>
          <div className="card-item-right-side-info-item-desc" dangerouslySetInnerHTML={{__html: this.l10n(item.desc)}}></div>
        </div>
      )
    }),
    btns = data.btns.map((item, index) => {
      const btn = (<button className={item.class} id={item.id}>{this.l10n(item.text)}</button>);
      return (
        item.href ? (
          <Link key={index} href={item.href}>
            {btn}
          </Link>
          ) : (
          <Link key={index} onClick={item.toggleModal}>
            {btn}
          </Link>
        )

      )
    });

    return (
        <div className={`card-item ${data.type}`}>
          {data.img ? <img className="card-item-img" src={data.img} alt="card-img"></img> : ''}
          <div className="card-item-right-side">
            <div className="card-item-right-side-title" dangerouslySetInnerHTML={{__html: this.l10n(data.name)}}></div>
            <div className="card-item-right-side-info">{infoItems}</div>
            <div className="card-item-right-side-btns">{btns}</div>
          </div>
        </div>
    );
}
